import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fieldset, UniversalSelect } from '@feathr/components';
import ExportDeliveryUserSelect from '@feathr/extender/components/ExportDeliveryUserSelect';
import { flattenError } from '@feathr/hooks';

import type { IExportTypeOption, IPersonFieldOption } from '../GroupExportModal.utils';
import type { ISimpleExportFormState } from './SimpleExportForm.hooks';

export interface ISimpleExportFormProps {
  state: ISimpleExportFormState;
}

function SimpleExportForm({ state }: Readonly<ISimpleExportFormProps>): JSX.Element {
  const { t } = useTranslation();

  const {
    deliveryUser,
    emailHadFocus,
    emailError,
    exportTypeOptions,
    selectedExportTypeOption,
    isCustomFieldsPending,
    fieldOptions,
    selectedFieldOptions,
    fieldsError,
    handleChangeMode,
    handleChangeDeliveryUser,
    handleClearDeliveryUser,
    handleSelectFields,
  } = state;

  return (
    <Fieldset>
      <UniversalSelect<IExportTypeOption>
        label={t('Export type')}
        name={'export-type'}
        onSelectSingle={handleChangeMode}
        options={exportTypeOptions}
        value={selectedExportTypeOption}
      />
      <UniversalSelect<IPersonFieldOption>
        isLoading={isCustomFieldsPending}
        isMulti={true}
        label={t('Fields')}
        menuPortalTarget={document.body}
        name={'export-fields'}
        onSelectMulti={handleSelectFields}
        options={fieldOptions}
        validationError={flattenError(fieldsError)}
        value={selectedFieldOptions}
      />
      <ExportDeliveryUserSelect
        menuPortalTarget={document.body}
        onChange={handleChangeDeliveryUser}
        onClear={handleClearDeliveryUser}
        validationError={emailHadFocus ? flattenError(emailError) : undefined}
        value={deliveryUser}
      />
    </Fieldset>
  );
}

export default SimpleExportForm;
